import React from "react";
import { images } from "../../constants";
import "./AboutUs.css";

const AboutUs = () => (
  <div
    className="app__aboutus app__bg flex__center section__padding"
    id="about"
  >
    <div className="app__aboutus-overlay flex__center">
      <img src={images.G} alt="G" />
    </div>

    <div className="app__aboutus-content flex__center">
      <div className="app__aboutus-content_about">
        <h1 className="headtext__cormorant">About Us</h1>
        <img src={images.spoon} alt="Spoon" className="spoon__img" />
        <p className="p__opensans">
          At Gericht, we blend passion and tradition to serve dishes that
          delight your palate. Our team is dedicated to delivering a fine dining
          experience with fresh ingredients, bold flavors, and timeless
          techniques.
        </p>
        <button type="button" className="custom__button">
          Know More
        </button>
      </div>

      <div className="app__aboutus-content_knife flex_center">
        <img src={images.knife} alt="Knife" />
      </div>

      <div className="app__aboutus-content_history">
        <h1 className="headtext__cormorant">Our History</h1>
        <img src={images.spoon} alt="about_spoon" className="spoon__img" />
        <p className="p__opensans">
          Established in 2001, Gericht was founded with a vision to bring a
          modern twist to traditional European cuisine. Over the years, we've
          grown into a culinary landmark known for innovation, hospitality, and
          unforgettable meals.
        </p>
        <button type="button" className="custom__button">
          Know More
        </button>
      </div>
    </div>
  </div>
);

export default AboutUs;
